import { render } from "./BonusIndicacao.vue?vue&type=template&id=0a65af62&scoped=true"
const script = {}

import "./BonusIndicacao.vue?vue&type=style&index=0&id=0a65af62&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a65af62"]])

export default __exports__